export function queryToStr(query) {
    let str = Object.keys(query)
        .map(key => key+'='+query[key])
        .join('&')
    return str?'?'+str:''
}